import { createReducer, on } from '@ngrx/store';
import { Licencia, LicenciaForm } from '@core/models';
import {
  LICENSE_FIND_SUCCESS,
  LICENSE_FAILURE,
  LICENSE_UPDATE_FORM,
  LICENSE_RESET_ERROR,
  LICENSE_RESET,
  LICENSE_RESET_FORM,
  LICENSE_FIND_ALL_SUCCESS,
  LICENSE_EDIT_MODE,
  LICENSE_CLEAR_STATE,
  LICENSE_UPDATE_LOADING,
  LICENSE_UPDATE_ID,
} from '@store/actions';
import { ResponseBadRequest } from '@core/interfaces/response-bad-request';
import { transformLicenseData } from '@core/helpers';

export interface LicenseState {
  loading: boolean;
  licenseList: Licencia[] | null;
  error: ResponseBadRequest | null;
  editMode: boolean;
  isEditing: boolean;
  licenseForm: LicenciaForm | null;
  licenseId: string | null;
  license: Licencia | null;
}

export const initialState: LicenseState = {
  loading: false,
  licenseList: null,
  error: null,
  editMode: false,
  isEditing: false,
  licenseForm: null,
  licenseId: null,
  license: null,
};

export const licenseReducer = createReducer(
  initialState,
  on(LICENSE_EDIT_MODE, (state, { editMode, isEditing }) => ({ ...state, editMode, isEditing })),
  on(LICENSE_FIND_SUCCESS, (state, { license }) => ({ ...state, license: transformLicenseData(license) })),
  on(LICENSE_FIND_ALL_SUCCESS, (state, { licenseList }) => ({ ...state, licenseList })),
  on(LICENSE_FAILURE, (state, { error }) => ({ ...state, error })),
  on(LICENSE_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(LICENSE_UPDATE_FORM, (state, { licenseForm }) => ({ ...state, licenseForm })),
  on(LICENSE_UPDATE_ID, (state, { licenseId }) => ({ ...state, licenseId })),
  on(LICENSE_RESET, (state) => ({ ...state, license: null, licenseId: null, licenseForm: null })),
  on(LICENSE_RESET_ERROR, (state) => ({ ...state, error: null })),
  on(LICENSE_RESET_FORM, (state) => ({ ...state, licenseForm: null, loading: false })),
  on(LICENSE_CLEAR_STATE, () => initialState),
);
